<p-toast />

<div *ngIf="customerName" style="text-align: center;">
  <h3>{{customerName}}</h3>
</div>

<div *ngIf="routes.length" style="height: 89vh;" >
  <p-tabMenu [model]="routes" [class.hidden]="hideMenu" [activeItem]="activeItem">
    <ng-template pTemplate="item" let-item>
      <ng-container *ngIf="item.path && !item.data?.hide">
        <a [routerLink]="item.path" class="p-menuitem-link">
          <span [class]="item.icon"></span>
          <span class="ml-2">
            {{ item.data?.label || item.title }}
          </span>
        </a>
      </ng-container>
    </ng-template>
  </p-tabMenu>

  <router-outlet/>
</div>